import React, {Component} from "react";
import {Card, Col, Row} from "react-bootstrap";
import './Skills.css';
import {portfolioData, sectionHeaders} from "../../../data/data";

class Skills extends Component {
    render() {
        return (
            <div className={'px-4 py-5 mt-5'} id='skills'>
                {sectionHeaders('skills')}
                <Row className={'py-5'}>
                    <Col md={5}>
                        <span style={{fontSize: '3em'}}><strong>What do I bring to the table?</strong></span>
                    </Col>
                    <Col md={7} className={'py-3'}>
                        <Card className={'px-4 py-3'} style={{fontWeight: 500}}>
                            <h4 className={'skill-heading'}>languages</h4>
                            {portfolioData.skills.languages}
                            <h4 className={'skill-heading mt-4'}>technologies & tools</h4>
                            {portfolioData.skills.tools}
                            <h4 className={'skill-heading mt-4'}>fields</h4>
                            {portfolioData.skills.fields}
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Skills;